import { Features } from '@/utils/Features'
import { CarAddonsSelector } from '../priceCalculator/PurchaseForm/OfferPresenter/CarAddonsSelector/CarAddonsSelector'
import { useCarExtensionOffers } from './CarTrialExtensionOffers/CarTrialExtensionOffers'

export function TrialExtensionAddonSelector() {
  const { selectedOffer, isSigningWithExtension, isExtendingAfterConnectingPayment } = useCarExtensionOffers()

  if (!Features.enabled('CAR_ADDONS')) return null
  if (!isSigningWithExtension && !isExtendingAfterConnectingPayment) return null
  if (selectedOffer.addons.length === 0) return null

  return <CarAddonsSelector offer={selectedOffer} />
}
